export default __webpack_public_path__ + "media/images/features/local_delivery/episode6/LP_04-78f31e209e07502188eb4b2f7bec0dbd.jpeg";